<template>
  <div class="drawing-page">
    <div class="title">{{ title }}</div>

    <div class="content">
      <div v-if="file" class="download">
        <img src="../../assets/file/download.png" @click="downloadFile" alt=""/>
        <img src="../../assets/file/delete.png" @click="deleteItem" alt=""/>
      </div>

      <div v-else>
        <el-upload
          :show-file-list="false"
          :http-request="uploadSectionFile"
          class="upload-demo"
          drag
          :action="uploadUrl"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";

export default {
  name: "Drawing",

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.file = this.$route.query.file;
    this.houseID = this.$route.query.houseID;
    this.orgID =  this.$route.query.orgID;

    if (this.file && this.file.length > 0) {
      this.title = "已上传图纸，请选择下载或删除";
    } else {
      this.title = "还未上传图纸，请上传";
    }

    this.uploadUrl = axios.defaults.baseURL + "houses/drawings/upload";
  },

  data() {
    return {
      title: "",
      token: "",
      file: "",
      houseID: "",
      orgID:"",
      uploadUrl: ""
    };
  },

  methods: {

    uploadSectionFile(params) {
      const file = params.file;
      // 根据后台需求数据格式
      const form = new FormData();
      // 文件对象
      form.append("file", file);
      // 本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
      form.append("houseID", this.houseID);
      form.append("orgID", this.orgID);
      // 项目封装的请求方法，下面做简单介绍
      axios
        .post(this.uploadUrl, form)
        .then(value => {
          if (value.data.code === 0) {
            this.$message.success(value.data.message);
            this.file = value.data.data;
            this.title = "已上传图纸，请选择下载或删除";
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(reason => {
          this.$message.error(reason.toString());
        })
        .finally(() => {
          this.$refs.upload.clearFiles();
        });
    },

    downloadFile() {
      let baseURL = axios.defaults.baseURL.replace("/v1/org", "");

      axios({
        method: "get",
        url: `${baseURL}drawings/${this.houseID}/${this.file}`,
        responseType: "blob"
      })
        .then(value => {
          Utils.convertRes2Blob(this.file, value);
          this.$message.success("文件下载成功");
        })
        .catch(e => {
          this.$message.error(e.toString());
        });
    },

    deleteItem() {
      let _vue = this;
      this.$confirm(
        `确认要删除该房源的消防图纸吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        axios({
          method: "post",
          url: "houses/drawings/remove",
          data: {
            houseID: this.houseID
          }
        })
          .then(value => {
            if (value.data.code === 0) {
              this.file = null;
              this.title = "还未上传图纸，请上传";
            }
            _vue.$message({
              type: "info",
              message: value.data.message
            });
          }).catch(() => {
          _vue.$message({
            type: "info",
            message: "删除失败"
          });
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.drawing-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.title {
  margin-top: 30px;
}
.content {
  margin-top: 20px;
  img {
    height: 120px;
    width: 120px;
    margin: 10px;
  }
}
</style>
